export default __webpack_public_path__ + "static/media/kava.0db0bb56.svg";